"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = exports.SWITCH_SIZES = void 0;
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var hooks_1 = require("../../../mantine-hooks/src");
var theme_1 = require("../../../mantine-theme/src");
var Switch_styles_1 = __importStar(require("./Switch.styles"));
exports.SWITCH_SIZES = Switch_styles_1.sizes;
function Switch(_a) {
    var className = _a.className, color = _a.color, label = _a.label, id = _a.id, style = _a.style, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.radius, radius = _c === void 0 ? 'xl' : _c, themeOverride = _a.themeOverride, wrapperProps = _a.wrapperProps, inputStyle = _a.inputStyle, inputClassName = _a.inputClassName, elementRef = _a.elementRef, others = __rest(_a, ["className", "color", "label", "id", "style", "size", "radius", "themeOverride", "wrapperProps", "inputStyle", "inputClassName", "elementRef"]);
    var classes = Switch_styles_1.default({
        size: size,
        color: color,
        radius: radius,
        reduceMotion: hooks_1.useReducedMotion(),
        theme: theme_1.useMantineTheme(themeOverride),
    });
    var uuid = hooks_1.useId(id);
    return (react_1.default.createElement("div", __assign({ className: clsx_1.default(classes.wrapper, className), style: style }, wrapperProps),
        react_1.default.createElement("input", __assign({ id: uuid, ref: elementRef, type: "checkbox", className: clsx_1.default(classes.switch, inputClassName), style: inputStyle }, others)),
        label && (react_1.default.createElement("label", { className: classes.label, htmlFor: uuid }, label))));
}
exports.Switch = Switch;
Switch.displayName = '@mantine/core/Switch';
